import { Component, input } from '@angular/core';
import { NgClass } from '@angular/common';

@Component({
  selector: 'mwe-list-item',
  templateUrl: './list-item.component.html',
  imports: [NgClass],
})
export class ListItemComponent {
  hasBackground = input<boolean>();
  dataTest = input<string>();
}
